import { Skeleton } from "@mui/material";
import useTitanApp from "@/hooks/useTitanApp";

export default function MarketplaceSettingsSkeleton() {
  const { appState } = useTitanApp();
  const { darkMode } = appState;
  const isDarkMode = darkMode;

  const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "", height: 40 };

  const mockApps = Array(6).fill(null);

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <Skeleton
          animation="wave"
          variant="text"
          width={180}
          height={32}
          sx={skeletonSx}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={140}
          height={36}
          className="rounded"
          sx={skeletonSx}
        />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {mockApps.map((_, index) => {
          return (
            <div
              key={index}
              className={`border rounded-lg p-6 hover:shadow-md transition-all duration-300 cursor-pointer ${
                isDarkMode
                  ? "border-gray-700 bg-gray-800 hover:bg-gray-750"
                  : "border-gray-200 hover:shadow-md"
              }`}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="text-3xl">
                    <Skeleton
                      variant="circular"
                      width={32}
                      height={32}
                      sx={skeletonSx}
                    />
                  </div>
                  <div>
                    <h3
                      className={`font-semibold flex items-center gap-2 transition-colors duration-300 ${
                        isDarkMode ? "text-white" : "text-gray-900"
                      }`}
                    >
                      <Skeleton
                        variant="text"
                        width={120}
                        height={24}
                        sx={skeletonSx}
                      />
                      <Skeleton
                        variant="rounded"
                        width={80}
                        height={18}
                        sx={skeletonSx}
                      />
                    </h3>
                    <Skeleton variant="rounded" width={60} height={18} />
                  </div>
                </div>
                <div className="text-right">
                  <Skeleton
                    variant="text"
                    width={60}
                    height={22}
                    sx={skeletonSx}
                  />
                  <Skeleton
                    variant="text"
                    width={80}
                    height={18}
                    sx={skeletonSx}
                  />
                </div>
              </div>

              <p
                className={`text-sm mb-4 line-clamp-2 transition-colors duration-300 ${
                  isDarkMode ? "text-gray-300" : "text-gray-600"
                }`}
              >
                <Skeleton
                  variant="text"
                  width="100%"
                  height={18}
                  sx={skeletonSx}
                />
                <Skeleton
                  variant="text"
                  width="90%"
                  height={18}
                  sx={skeletonSx}
                />
              </p>

              <div className="flex items-center justify-between">
                <div className="flex flex-wrap gap-1">
                  <Skeleton
                    variant="rounded"
                    width={50}
                    height={20}
                    sx={skeletonSx}
                  />
                  <Skeleton
                    variant="rounded"
                    width={60}
                    height={20}
                    sx={skeletonSx}
                  />
                  <Skeleton
                    variant="rounded"
                    width={40}
                    height={20}
                    sx={skeletonSx}
                  />
                </div>
                <Skeleton
                  variant="rounded"
                  width={100}
                  height={36}
                  sx={skeletonSx}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
